var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCl8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 128,
    viewBox: "0 0 240 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_729_1199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 48,
    width: 81,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1729 48H159.173V80H79.1729V48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_729_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.124 48H95.222C86.395 48 79.1729 55.1999 79.1729 63.9999V64C79.1729 72.8001 86.395 80 95.222 80H143.124C151.951 80 159.173 72.8001 159.173 64V63.9999C159.173 55.1999 151.951 48 143.124 48Z",
    fill: "#2A3342"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9854 63.7258C87.9854 59.9694 90.8782 57.2812 94.7711 57.2812C96.9318 57.2812 98.7354 58.0645 99.914 59.4888L98.0569 61.1978C97.2175 60.2365 96.1639 59.738 94.914 59.738C92.5746 59.738 90.914 61.3758 90.914 63.7258C90.914 66.0756 92.5746 67.7135 94.914 67.7135C96.1639 67.7135 97.2175 67.215 98.0569 66.2359L99.914 67.9449C98.7354 69.3869 96.9318 70.1702 94.7532 70.1702C90.8782 70.1702 87.9854 67.482 87.9854 63.7258Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.485 65.0967L110.503 60.3257L108.521 65.0967H112.485ZM113.396 67.2864H107.592L106.485 69.9567H103.521L109.092 57.4951H111.949L117.538 69.9567H114.503L113.396 67.2864Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.397 59.845H125.039V64.1888H127.397C129.164 64.1888 130.057 63.3699 130.057 62.0169C130.057 60.6462 129.164 59.845 127.397 59.845ZM130.111 69.9567L127.7 66.4853H127.557H125.039V69.9567H122.146V57.4951H127.557C130.897 57.4951 132.986 59.2219 132.986 62.0169C132.986 63.8862 132.039 65.2569 130.414 65.9512L133.218 69.9567H130.111Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.466 64.4736V57.4951H141.359V64.3669C141.359 66.7345 142.394 67.7137 144.144 67.7137C145.912 67.7137 146.93 66.7345 146.93 64.3669V57.4951H149.787V64.4736C149.787 68.1409 147.68 70.1703 144.127 70.1703C140.573 70.1703 138.466 68.1409 138.466 64.4736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCl8);
export default __webpack_public_path__ + "static/media/cl8.80c3614a9668435b735a0699a63855a1.svg";
export { ForwardRef as ReactComponent };